export type AddressCountryShortCodeType = 'FI' | 'GB' | 'SE';

export type AnelmaCultureType = 'fi' | 'fi-FI' | 'en-GB' | 'sv-SE';

export type GUIDType = string;

export const EmptyGUID = '00000000-0000-0000-0000-000000000000';

export type LanguageShortCodeType = 'FI' | 'GB' | 'SE';
